import React from 'react';
import { Building2, Mail, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="relative z-10 border-t border-slate-800/60 py-12 mt-12 bg-[#080d18]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="p-1.5 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg">
                <Building2 className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="font-bold text-white">FM Flexi Pro<span className="text-teal-400 text-xs align-top ml-0.5">™</span></div>
                <div className="text-xs text-muted-foreground">A product by SKG Apps</div>
              </div>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed">UAE's smartest, AI-enabled Facilities Management platform — built for property managers who value time.</p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-muted-foreground">
              <li><a href="#features" className="hover:text-teal-400">Modules</a></li>
              <li><button onClick={() => navigate('/help')} className="hover:text-teal-400">Help & FAQ</button></li>
              <li><button onClick={() => navigate('/contact')} className="hover:text-teal-400">Contact</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-muted-foreground">
              <li className="flex items-center gap-2"><Mail className="w-3 h-3" /><a href="mailto:info@sgkapps.com" className="hover:text-teal-400">info@sgkapps.com</a></li>
              <li>SKG Apps · Made in UAE</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-3">Get Started</h4>
            <button data-testid="footer-contact-btn" onClick={() => navigate('/contact')} className="inline-flex items-center gap-1.5 text-sm text-teal-400 hover:text-teal-300">Talk to us<ArrowRight className="w-3 h-3" /></button>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} SKG Apps · All rights reserved</div>
          <div>Powered by Emergent · Claude Sonnet AI</div>
        </div>
      </div>
    </footer>
  );
}
